import { render } from "./ModalUnidadesPorProducto.vue?vue&type=template&id=278936ec&scoped=true"
import script from "./ModalUnidadesPorProducto.vue?vue&type=script&lang=js"
export * from "./ModalUnidadesPorProducto.vue?vue&type=script&lang=js"

import "./ModalUnidadesPorProducto.vue?vue&type=style&index=0&id=278936ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278936ec"]])

export default __exports__